module.exports = __webpack_public_path__ + "img/ontowallet.a0445c15.svg";